module.exports = __webpack_public_path__ + "img/Girl_030006.d36a6445.png";